import React from "react";

const NavItem = ({ title, to }) => {
  return (
    <li className="p-2 flex items-center hover:scale-125 transition ease-in-out delay-150 duration-300">
      <a
        href={to}
        className="text-center bg-white px-4 py-2 rounded outline-none  text-gray-600 hover:text-gray-900 hover:text-underline"
      >
        <span className="font-bold text-xl">{title}</span>
      </a>
    </li>
  );
};

export default NavItem;
